module.exports = __webpack_public_path__ + "img/Wearable-shadow.188b49d7.png";